import { useQuery } from 'react-query';

import { actionTemplatesApi } from 'config/api/actionLibrary/actionLibrary';
import { RecommendedAsset } from 'config/api/actionLibrary/actionLibrary.types';

interface UseAssetSelectionDataParams {
  templateId?: number;
  search: string;
}

interface UseAssetSelectionDataReturn {
  recommendedAssets: RecommendedAsset[];
  availableAssets: any[];
  isLoading: boolean;
  error: Error | null;
}

/**
 * Custom hook for fetching asset selection data
 */
const useAssetSelectionData = ({ templateId, search }: UseAssetSelectionDataParams): UseAssetSelectionDataReturn => {
  // Fetch recommended assets from template
  const {
    data: recommendedAssetsData,
    isLoading: isLoadingRecommended,
    error: recommendedError,
  } = useQuery(['recommendedAssets', templateId, search], () => actionTemplatesApi.getRecommendedAssets(Number(templateId!), { search }), {
    enabled: !!templateId,
    select: data => {
      // Extract results from the parsed response
      const results = data?.data?.results || [];
      return results;
    },
  });

  // Fetch all available assets
  const { data: availableAssetsData, isLoading: isLoadingAvailable } = useQuery(
    'availableAssets',
    () => actionTemplatesApi.getAvailableAssets(),
    {
      select: data => data.data.assets || [],
    },
  );

  return {
    recommendedAssets: recommendedAssetsData || [],
    availableAssets: availableAssetsData || [],
    isLoading: isLoadingRecommended || isLoadingAvailable,
    error: recommendedError as Error | null,
  };
};

export default useAssetSelectionData;
